<shared-generalstatus-container *ngIf="route" [generalStatus]="route.generalStatus" (dragover)="dragover($event)"
    (drop)="dropAtZone($event)">
    <div class="card">
        <div class="infopackage">
            <div class="package">
                <div class="prompt">{{ 'TRUCKING.ROUTE.ROUTEKEY.CAPTION' | translate}}</div>
                <shared-copyclipboard *ngIf="route.routeKey" class="packageKey"
                    [value]="route.routeKey">{{route.routeKey}}
                </shared-copyclipboard>
            </div>
            <div class="package" *ngIf="route.title">
                <div class="prompt">{{ 'TRUCKING.ROUTE.CUSTOMERREFERENCE.CAPTION' | translate}}</div>
                <shared-copyclipboard *ngIf="route.title" class="packageKey" [value]="route.title">{{route.title}}
                </shared-copyclipboard>
            </div>
            <div class="line route-description ellipsis">{{ route.line1 }}
            </div>
            <div class="line route-description ellipsis">{{ route.line3 }}
            </div>
        </div>
        <div class="bottom-zone">
            <shared-trucking-route-strip-card-component [route]="route"></shared-trucking-route-strip-card-component>
        </div>
    </div>
</shared-generalstatus-container>